import {z} from '@hono/zod-openapi';

const equipmentSchema = z.array(
  z.object({
    externalId: z.string().regex(/^\d+$/).nullable().openapi({
      description: 'Eurotax option code; rows without a code cannot be mapping targets',
      example: '116690',
    }),
    label: z.string().nullable(),
  })
);

export const automarketplEquipmentResponseSchema = z
  .object({
    eurotaxCode: z.number().int().safe().positive().openapi({example: 142591}),
    registrationDate: z.string().date().openapi({example: '2023-03-03'}),
    standardEquipment: equipmentSchema,
    optionalEquipment: equipmentSchema,
  })
  .openapi('AutomarketplEquipmentResponse');

export type AutomarketplEquipmentResponse = z.infer<typeof automarketplEquipmentResponseSchema>;
